<template>
    <div>
        <vTable
            class="margin-15"
            :columns="columns" 
            :data="datalist"
            size="small" 
            ref="tabledoc"  
            border
        > </vTable>
    </div>
</template>
<script>
import { HttpGetAppointList } from '@/service/inbound';
import { mapState } from 'vuex';
// 
export default {
    props:['activeid'],
    data(){
        return {
            datalist:[],
        }
    },
    created(){
        this.getDetail()
    },
    computed:{
        ...mapState(['organization']),
        getStatus(){
            return [
                {
                    name: "ALL",
                    key: "EQ_status",
                    val: null
                },
                {
                    name: "Draft",
                    key: "EQ_status",
                    val: "0",
                    theme: "primary"
                },
                {
                    name: "Pending",
                    key: "EQ_status",
                    val: "1",
                    theme: "info"
                },
                {
                    name: "Approved",
                    key: "EQ_status",
                    val: "2",
                    theme: "success"
                },
                {
                    name: "Rejected",
                    key: "EQ_status",
                    val: "3",
                    theme: "warning"
                },
                {
                    name: "Unloaded",
                    key: "EQ_status",
                    val: "4"
                    // theme: "info"
                },
                {
                    name: "Cancelled",
                    key: "EQ_status",
                    val: "5"
                    // theme: "error"
                }
            ];
        },
        columns(){
            return [
                {
                    title: "Reservation No.",
                    key: 'reserveInboundNo',
                    render: (h, { row }) => {
                        // console.log(this.organization)
                        return <div>
                            <a onClick={this.handleOperates.bind(this, row.id, 'blankinboundno',this.organization.roleLabel)}>{row.reserveInboundNo}</a>
                        </div>
                    }
                }, {
                    title: "Status",
                    render: (h, { row }) => {
                        const { name, theme } =
                            this.getStatus.find(function (item) {
                                return item.val == row.status;
                            }) || {};
                        return (
                            <vButton
                                ghost
                                theme={theme}
                                size="small"
                                class="cursor-default"
                                style="min-width:70px;"
                            >
                                {name}
                            </vButton>
                        );
                    }
                }, {
                    title: "Cargo Form",
                    key:'goodTypeName',
                    render: (h, { row }) => {
                        return row.goodTypeName || '--';
                    }
                },
                {
                    title: "Container No.",
                    key:'containerNo',
                    render: (h, { row }) => {
                        return row.containerNo || '--';
                    }
                },
                {
                    title: "Scheduled Delivery Time",
                    key:'reserveInboundDate',
                    sortable:true,
                    render: (h, { row }) => {
                        return row.reserveInboundDate || '--';
                    }
                },
                {
                    title: "Actual Arrival Time",
                    key:'arriveDate',
                    sortable:true,
                    render: (h, { row }) => {
                        return row.arriveDate || '--';
                    }
                },
                {
                    title: "Container Empty Time",
                    key:'containerEmptyTime',
                    sortable:true,
                    render: (h, { row }) => {
                        return row.containerEmptyTime || '--';
                    }
                },
            ]
        }
    },
    methods:{
        handleOperates(params="", type,routedata){

            switch (type) {
                case "blankinboundno":
                    let routename,routetype;
                    if(routedata === 'client'){
                        routename = 'bespeakCustom'+ "Query";
                        routetype = 'MERCHANT'
                    }else if(routedata === 'service'){
                        routename = 'bespeakManage'+ "Query";
                        routetype = 'WAREHOUSE'
                    }
                    var url=this.$router.resolve({
                        name: routename,
                        query: { id: params, routetype }
                    });
                    window.open(url.href, '_blank');
                    break;
            }
        },
        getDetail(){
            HttpGetAppointList({
                inboundOrderNo:this.activeid
            }).then(res=>{
                this.datalist = res.data
            },err=>{
                this.$VMessage.error(err.message)
            })
        },
    }
}
</script>